"use client";


import { ActionIcon, Tooltip, useMantineColorScheme, rem, Stack, Text, Group } from "@mantine/core";
import { Minimize, Activity } from "lucide-react";

export interface DashboardFullscreenHeaderProps {
    dashboardName: string;
    autoRefreshEnabled: boolean;
    handleFullscreenToggle: () => void;
    lastRefreshDate: Date | null;
}

export function DashboardFullscreenHeader({
    dashboardName,
    autoRefreshEnabled,
    handleFullscreenToggle,
    lastRefreshDate
}: DashboardFullscreenHeaderProps) {
    const { colorScheme } = useMantineColorScheme();

    return (
        <div
            className="flex-none px-4 py-3 flex items-center justify-between z-10"
            style={{
                borderBottom: '1px solid var(--modal-border)',
                backgroundColor: colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'var(--mantine-color-white)'
            }}
        >
            <Group gap="xl" align="center">
                <h2 className="text-lg font-semibold truncate m-0">
                    {dashboardName}
                </h2>
            </Group>


            <Group gap="md" align="center">
                {lastRefreshDate && (
                    <Stack gap={2} align="flex-end">
                        <Group gap={4} align="center">
                            {autoRefreshEnabled && (
                                <Activity size={14} color="var(--mantine-color-green-6)" className="animate-pulse" />
                            )}
                            <Text size="xs" c="dimmed" fw={700} style={{ textTransform: 'uppercase', letterSpacing: rem(0.5) }}>
                                Last Refresh
                            </Text>
                        </Group>
                        <Text size="sm" fw={600}>
                            {lastRefreshDate.toLocaleTimeString()}
                        </Text>
                    </Stack>
                )}

                <Tooltip label="Exit Fullscreen">
                    <ActionIcon
                        variant="light"
                        color="gray"
                        size="lg"
                        onClick={handleFullscreenToggle}
                    >
                        <Minimize size={20} />
                    </ActionIcon>
                </Tooltip>
            </Group>
        </div>
    );
}
